import { useRouter } from 'next/router';
import {
  NAMESPACE_MAP,
  namespaceFromUrl,
  NamespacePath,
} from '@ads-bread/shared/bread/util';

/**
 * Returns the namespace of the current URL (RBC, alliance, in-store)
 *
 * @throws Error when namespace cannot be determined from the URL
 *
 */
export function useNamespace(): NamespacePath {
  const router = useRouter();
  const namespace = namespaceFromUrl(router.pathname);

  if (!namespace) {
    return NAMESPACE_MAP.NoMatch;
  }
  return namespace;
}
